import { LoyaltyApplicationLevel, LoyaltyOfferType } from "../../loyaltyTypes";
import { LoyaltyCartOffer } from "../LoyaltyCartOffer";
import { LoyaltyItemOffer } from "../LoyaltyItemOffer";
import LoyaltyOffer from "../LoyaltyOffer";

export const createLoyaltyOffer = (offer: LoyaltyOfferType): LoyaltyOffer => {
  return createLoyaltyOfferByCategory(offer);
};

/** @deprecated Use {@link createLoyaltyOffer} — item-level offers are already LoyaltyItemOffer. */
export const createLoyaltyItemOffer = (
  offer: LoyaltyOfferType
): LoyaltyItemOffer => {
  return new LoyaltyItemOffer(offer);
};

const createLoyaltyOfferByCategory = (
  offer: LoyaltyOfferType
): LoyaltyOffer => {
  switch (offer.applicationLevel) {
    case LoyaltyApplicationLevel.ITEM:
      return new LoyaltyItemOffer(offer);
    case LoyaltyApplicationLevel.CART:
    default:
      return new LoyaltyCartOffer(offer);
  }
};
